import { useRouter } from 'next/router'
import {
  DefaultContent,
  DefaultLang,
  DefaultSort,
  DefualtScope,
  DefaultInitImage,
} from '~/utils/search'

export default function useSearchParams() {
  const router = useRouter()
  /** 选中的artist id */
  const artistid = Number(router.query.artistid) || undefined
  /** 选中的主题 */
  const themeid = Number(router.query.themeid) || undefined
  /** 选中的L1 tab */
  const l_1 = String(router.query.l_1 || '全部')
  /** 选中的L2 tab */
  const l_2 = Number(router.query.l_2) || 0
  /** 选中的leaf */
  const activeLeaf = String(router.query.leaf || '')
    .split('.')
    .map(item => Number(item))
    .filter(item => !!item)
  /** 搜索词 */
  const keywords = String(router.query.keywords || '')
  /** 当前artist tab对应的index */
  const artistTabIndex = Number(router.query.artisttabindex) || 0

  /** 排序筛选 */
  const sort = String(router.query.sort || '') || DefaultSort
  const scope = String(router.query.scope || '') || DefualtScope
  const content = String(router.query.content || '') || DefaultContent
  const lang = String(router.query.lang || '') || DefaultLang
  const initImage = String(router.query.initImage || '') || DefaultInitImage
  const modelType = String(router.query.modeltype || '') || undefined
  const size = String(router.query.size || '') || undefined
  const visibleType = String(router.query.visibleType || '') || undefined

  return {
    artistid,
    themeid,
    l_1,
    l_2,
    activeLeaf,
    keywords,
    artistTabIndex,
    sort,
    scope,
    content,
    lang,
    initImage,
    modelType,
    size,
    visibleType,
  }
}
